export const messengerMixin = {

  methods: {
    getMessengerName(messengerName) {
      const messengerMap = {
        Telegram: 'telegram',
        WhatsApp: 'whatsapp',
        Viber: 'viber',
        Messenger: 'messenger',
        Instagram: 'instagram',
        X: 'twitter_x',
        WeChat: 'wechat'
      };

      return messengerMap[messengerName] || 'telegram';
    }
  }
};
